@if (!isLoading) {
  <div class="mt-3 h-100">
    @if (campanhas; as camp) {
      <div class="mt-3 h-100">
        @if (camp.campaignShop.length > 0 && !isLoading) {
          <div class="divs-orientation">
            @if (camp.campaignShop.length > 0) {
              <div class="banner-campaign">
                @for (campaign of camp.campaignShop; track campaign) {
                  <div [class.hover15]="campaign.type === 'DH'"
                    [class.hover14]="campaign.type !== 'DH' && campaign.name !== 'Destaques'"
                    [class.hover16]="campaign.name === 'Destaques'"
                    [class.hover17]="campaign.type === 'P1' || campaign.type === 'P2' || campaign.type === 'P3' || campaign.type === 'P4' || campaign.type === 'DH'">
                    @if (!campaign.image?.endsWith('.mp4') && !campaign.image?.endsWith('.webm') && campaign.name !== 'Destaques' && !publicidades) {
                      <figure>
                        <img
                          [src]="campaign.image === 'banner_placeholder.png' ? '../../../assets/images/banner_placeholder.png' : env.campaigns_images + campaign.image"
                          alt="{{campaign.name}}" (click)="getCampaignDetails(campaign)" class="adjusts" />
                        </figure>
                      }
                      @if (!campaign.image?.endsWith('.mp4') && !campaign.image?.endsWith('.webm') && publicidades && campaign.name !== 'Destaques') {
                        <figure>
                          <img
                            [src]="campaign.header ? env.campaigns_images + campaign.header : '../../../assets/images/banner_placeholder.png'"
                            alt="{{campaign.header}}" (click)="getCampaignDetails(campaign)" class="adjusts" />
                          </figure>
                        }
                        @if (campaign.name === 'Destaques') {
                          @for (product of campaign.products; track product) {
                            <app-product-shop [product]="product">
                            </app-product-shop>
                          }
                        }
                        @if (campaign.image?.endsWith('.mp4')) {
                          <video autoplay muted loop id="campaign-video-mp4" alt="Vídeo de campanha"
                            (click)="getCampaignDetails(campaign)" class="adjusts">
                            <source [src]="env.campaigns_images + campaign.image" type="video/mp4">
                          </video>
                        }
                        @if (campaign.image?.endsWith('.webm')) {
                          <video autoplay muted loop id="campaign-video-webm" alt="Vídeo de campanha"
                            (click)="getCampaignDetails(campaign)" class="adjusts">
                            <source [src]="env.campaigns_images + campaign.image" type="video/webm">
                          </video>
                        }
                        @if (campaign.name !== 'Destaques') {
                          <span (click)="getCampaignDetails(campaign)">{{campaign.name}}</span>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (camp.campaignShop.length == 0) {
              <div class="content centering h-100">
                <div class="unavailable">De momento não existem campanhas ativas</div>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="loading-animation h-100" role="alert" aria-live="assertive">
        <app-loading></app-loading>
      </div>
    }
